import MediaGalleryForm from '../../../components/Forms/Websites/MediaGalleryForm/MediaGalleryForm';
import CrudLayout from '../../../components/Layout/CrudLayout';

const Associates = () => {
    const columns = [
        {
            name: 'Title',
            selector: (row) => row?.title,
            sortable: true,
        },
        {
            name: 'Image',
            wrap: true,
            width: '150px',
            cell: (row) => (
                <img
                    style={{ width: '100%' }}
                    src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image}`}
                    alt='side Img'
                />
            ),
        },
        {
            name: 'Description',
            wrap: true,
            center: true,
            selector: (row) => row?.description,
        },
        {
            name: 'Status',
            selector: (row) => row?.status,
            sortable: 'true',
            center: 'true',
            // eslint-disable-next-line react/no-unstable-nested-components
            cell: (data) => <span>{data.status === 1 ? 'Active' : 'Inactive'}</span>,
        },
    ];

    const initialValues = {
        title: '',
        image: '',
        associate_group: 'associate',
        description: '',
        status: 1,
    };

    const config = {
        table_name: 'Associate List',
        create_modal_title: 'Create New Associate',
        update_modal_title: 'Update New Associate',
        link: 'media-gallery',
        getLink: 'media-gallery?group=associate',
        columns,
        form: <MediaGalleryForm />,
        initialValues,
        hasImage: true,
    };

    return <CrudLayout config={config} />;
};

export default Associates;
